const isNullOrUndefined = (value) => value === null || value === undefined;

window.CookiesHelper = {
  set: (name, value, options) => {
    const defaultOptions = { path: '/', expires: 365, sameSite: 'strict' };
    const mergedOptions = { ...defaultOptions, ...options };
    const expires = new Date(Date.now() + mergedOptions.expires * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=${mergedOptions.path}; samesite=${mergedOptions.sameSite}`;
  },
  get: (name) => {
    const cookieName = `${name}=`;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      if (cookie.trim().startsWith(cookieName)) {
        return cookie.trim().substring(cookieName.length);
      }
    }
    return null;
  },
  remove: (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; samesite=strict`;
  }
}

const initCssVideo = (wrapperSelector)=> {
  const ANIMATION_INIT_CLASS = 'product-video-animation'
  const ANIMATION_IMAGE_CLASS = 'css-video-img-js'
  const imageWrapper = document.querySelector(`${wrapperSelector} [data-product-carousel]`)
  if (isNullOrUndefined(imageWrapper)) return
  const productMainImage = imageWrapper.querySelector('img[alt*=css-video]')
  if (isNullOrUndefined(productMainImage)) return
  productMainImage.classList.add(ANIMATION_IMAGE_CLASS)
  let imageAnimationsCounter = 0

  const playAnimation = () => {
    imageWrapper.classList.toggle(ANIMATION_INIT_CLASS, true)
  }
  const stopAnimation = () => {
    imageWrapper.classList.toggle(ANIMATION_INIT_CLASS, false)
    imageAnimationsCounter = 0
  }

  const autoStopInit = () => {
    imageWrapper.addEventListener('animationend', (e) => {
      if (e.target.tagName !== 'IMG') return
      imageAnimationsCounter === 1 ? stopAnimation() : imageAnimationsCounter++
    })
  }

  const initPlaying = () => {
    if (imageWrapper?.selectedCell?.querySelector('img')?.classList?.contains(ANIMATION_IMAGE_CLASS)) {
      playAnimation()
    } else {
      stopAnimation()
    }
  }

  autoStopInit()

  productMainImage.addEventListener('load', () => {
    initPlaying()
  });
  // setTimeout(() => {
  //   initPlaying()
  // }, 1000)
  imageWrapper.addEventListener('carousel:settle', () => {
    // console.log('carousel:settle')
    initPlaying()
  })

  const thumbnailImg = document.querySelector('[data-product-thumbnail] img[alt*=css-video]')
  if (isNullOrUndefined(thumbnailImg)) return
  thumbnailImg.parentElement.classList.add('product-video-thumbnail')
  const playIcon = document.createElement('svg')
  thumbnailImg.insertAdjacentElement('afterend', playIcon)
  playIcon.outerHTML = '<svg style="position: absolute; left: 50%; top: 50%; transform: translate3d(-50%, -50%, 0); width: 50%;" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 562.746 562.746" stroke="currentColor"><path d="M281.37,0C125.977,0,0.003,125.974,0.003,281.373c0,155.399,125.974,281.373,281.373,281.373 c155.393,0,281.367-125.974,281.367-281.373C562.743,125.974,436.769,0,281.37,0z M484.212,305.425L192.287,471.986 c-23.28,13.287-42.154,2.326-42.154-24.479V115.239c0-26.805,18.874-37.766,42.154-24.479l291.925,166.562 C507.491,270.602,507.491,292.145,484.212,305.425z"></path></svg>'
  thumbnailImg.parentElement.addEventListener('click', () => {
    initPlaying()
  })
}

if (document.querySelector('.product [data-product-carousel]')) {
  initCssVideo('.product')
}

// Observe mutations in the DOM
const observer = new MutationObserver((mutationsList) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.tagName === 'QUICK-BUY-MODAL') {
          // console.log('quick-buy-modal added')
          // Add event listener to the new modal
          node.addEventListener('dialog:after-show', () => {
            // console.log('dialog:after-show')
            initCssVideo('.quick-buy-modal__content')
          })
        }
      });
    }
  });
});

// Start observing the body for added nodes
observer.observe(document.body, { childList: true, subtree: true });

// Detect user's country and remove elements based on location
(async function () {
  // 1. Helper: Cache location data in sessionStorage
  function setSessionStorage(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  // 2. Helper: Retrieve location data from sessionStorage
  function getSessionStorage(key) {
    const storedValue = sessionStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : null;
  }

  // 3. Function to fetch GeoIP location data
  async function fetchLocation() {
    try {
      // Replace with your preferred GeoIP API (e.g., ipapi.co, ipstack.com, ipinfo.io)
      const response = await fetch('https://ipapi.co/json/');
      if (!response.ok) throw new Error('Failed to fetch location data');
      return await response.json();
    } catch (error) {
      console.error('Error fetching location data:', error);
      return null;
    }
  }

  // 4. Main Function: Detect user's country and cache
  async function detectUserLocation() {
    // First, check sessionStorage for cached data
    const cachedLocation = getSessionStorage('user_location');
    if (cachedLocation) {
      console.log('Using cached location from sessionStorage:', cachedLocation);
      return cachedLocation;
    }

    // If not cached, fetch new location data
    const location = await fetchLocation();
    if (location) {
      // console.log('Fetched location data:', location);

      // Cache location in sessionStorage for the session
      setSessionStorage('user_location', location);

      return location;
    }

    return null;
  }

  // 5. Function to remove elements matching the selector
  function removeElements(selector) {
    const elements = document.querySelectorAll(selector);
    elements.forEach((element) => element.parentElement.remove());
    console.log(`${elements.length} elements removed matching selector: "${selector}"`);
  }

  // 6. Execute location detection and element removal
  const userLocation = await detectUserLocation();
  if (userLocation && userLocation.country === 'US') {
    console.log('User is from the US.');
  } else {
    console.log(`User is from ${userLocation?.country || 'an unknown location'}`);
    // Remove elements with the selector '.custom-validate-js input[name="contact[note]"]'
    removeElements('.custom-validate-js input[name="contact[note]"], [data-hide-non-us] > p');
  }
})();

// Adjust price based on automatic applied discount
const adjustPriceBasedOnDiscount = () => {
  const discountCodeFromCookie = CookiesHelper.get('discount_code');
  if (!discountCodeFromCookie) return;
  const adjustedDiscountCode = discountCodeFromCookie.replace('+', ' ');

  const discountData = window.__d_metafields_data;
  if (!discountData) return;

  const discount = discountData.find((item) => item.title === adjustedDiscountCode);
  if (!discount || discount['fixed']) return;

  document.querySelectorAll('[data-product-card-price]').forEach((priceEl) => {
    if (priceEl.dataset?.productCardPrice === 'adjusted') return;
    const parsedPriceArray = priceEl.textContent.replace(/,/g, '').match(/\d+(\.\d+)?/g);
    if (!parsedPriceArray) return;

    const parsedPrice = parseFloat(parsedPriceArray.join('.'));
    if (!parsedPrice) return;

    // const currencySymbol = priceEl.textContent.match(/[^0-9.,]/g)[0];
    const currencySymbol = Shopify.currency._symbol;
    const priceAfterDiscount = parsedPrice * (1 - discount.value / 100);

    priceEl.innerHTML = `<s style="font-size: .7em; font-weight: normal;">${currencySymbol}${parsedPrice.toFixed(2)}</s> ${currencySymbol}${priceAfterDiscount.toFixed(2)}`;
    priceEl.dataset.productCardPrice = 'adjusted';
  });
}

adjustPriceBasedOnDiscount();

// All related to the custom validation
document.addEventListener("DOMContentLoaded", () => {
  // Select the input field
  const contactNoteInput = document.querySelector('.custom-validate-js [name="contact[note]"]');
  const submitButton = document.querySelector('.custom-validate-js [type="submit"]');

  if (!contactNoteInput) return;

  // Function to validate if the value is a valid US E.164 phone number
  function isValidUSE164(phoneNumber) {
    const usE164Regex = /^\+1\d{10}$/; // +1 followed by exactly 10 digits
    return usE164Regex.test(phoneNumber);
  }

  // Add event listener for input blur or form submission
  contactNoteInput.addEventListener("input", () => {
    const value = contactNoteInput.value.trim(); // Get the trimmed input value

    // Validate the value
    if (!isValidUSE164(value)) {
      // Input is invalid for US E.164
      contactNoteInput.classList.add("invalid");
      contactNoteInput.classList.remove("valid");
      submitButton.setAttribute("disabled", "disabled");

      // Display an error message
      let errorMessage = document.querySelector("#phone-error-message");
      if (!errorMessage) {
        errorMessage = document.createElement("span");
        errorMessage.id = "phone-error-message";
        errorMessage.style.color = "red";
        contactNoteInput.parentNode.appendChild(errorMessage);
      }
      errorMessage.textContent = "Invalid phone number. Use E.164 format (+1XXXXXXXXXX) for US.";
    } else {
      // Input is valid
      contactNoteInput.classList.add("valid");
      contactNoteInput.classList.remove("invalid");
      submitButton.removeAttribute("disabled");

      // Remove the error message if it exists
      const errorMessage = document.querySelector("#phone-error-message");
      if (errorMessage) {
        errorMessage.remove();
      }
    }
  });
});

window.onload = async () => {
  const initSwat = () => {
    const swat = window._swat

    const updateWishlistDot = () => {
      swat.fetchWishlistCount(({ data }) => {
        document.querySelectorAll('.wishlist__dot').forEach(el => {
          el.classList.toggle('is-visible', data.count > 0)
        })
      })
    }

    updateWishlistDot()

    swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, () => updateWishlistDot())
    swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, () => updateWishlistDot())
  }

  const attempts = 5
  let count = 0
  const interval = setInterval(() => {
    if (window._swat) {
      clearInterval(interval)
      initSwat()
    }
    count++
    if (count >= attempts) {
      clearInterval(interval)
    }
  }, 1000)

//   custom redirect
  const observer = new MutationObserver(() => {
    const loginButton = document.querySelector('.swym-storefront-layout-login-button');
    if (loginButton) {
      const returnUrl = window.location.pathname + window.location.search + window.location.hash;
      const encodedReturnUrl = encodeURIComponent(returnUrl);

      loginButton.href = `/customer_authentication/login?return_to=${encodedReturnUrl}`;
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// A/B Testing
document.addEventListener("DOMContentLoaded", () => {
  const initPreviewSendCheckboxAB = () => {
    if (document.querySelector('.ab-preview-send-checkbox')) return;

    const $el = document.createElement('label');
    $el.classList.add('ab-preview-send-checkbox');
    $el.innerHTML = `
      <input type="checkbox" name="properties[__send_preview]" value="true">
      Send a preview of my painting before shipping
    `;

    const $parent = document.querySelector('.jd-buy-buttons_wrapper');
    const $nextSibling = $parent.querySelector('buy-buttons');

    if ($parent && $nextSibling) {
      $parent.insertBefore($el, $nextSibling);
    }
  }

  const initPaymentMessagesAB = () => {
    document.querySelector('.product-info__block-list')?.classList.add('payment-messages-ab');

    const paymentTerms = document.querySelector('[data-block-id=payment_terms]');
    const handPaintedText = document.querySelector('[data-block-id=text_Dz6HVY]');
    const shippingText = document.querySelector('[data-group-type=feature-badge-list]');

    if (!paymentTerms || !handPaintedText || !shippingText) return;

    paymentTerms.parentElement.insertBefore(shippingText, paymentTerms);
    handPaintedText.parentElement.insertBefore(paymentTerms, handPaintedText);
    shippingText.parentElement.appendChild(handPaintedText);
  }

  if (document.body.getAttribute('data-template') === 'product') {
    const abValue = CookiesHelper.get('paymentMessagesAB');
    if (abValue) initPaymentMessagesAB();

    const previewSendCheckboxAB = CookiesHelper.get('previewSendCheckboxAB');
    if (previewSendCheckboxAB) initPreviewSendCheckboxAB();
  }

  window.previewSendCheckboxAB = (enable = true) => {
    if (document.body.getAttribute('data-template') !== 'product') return;

    if (!enable) {
      CookiesHelper.remove('previewSendCheckboxAB');
      return;
    }

    const abValue = CookiesHelper.get('previewSendCheckboxAB');
    if (abValue) return initPreviewSendCheckboxAB();

    initPreviewSendCheckboxAB();
    CookiesHelper.set('previewSendCheckboxAB', 'true', { expires: 14 });
  }

  window.paymentMessagesAB = (enable = true) => {
    if (document.body.getAttribute('data-template') !== 'product') return;

    if (!enable) {
      CookiesHelper.remove('paymentMessagesAB');
      return;
    }

    const abValue = CookiesHelper.get('paymentMessagesAB');
    if (abValue) return initPaymentMessagesAB();

    initPaymentMessagesAB();
    CookiesHelper.set('paymentMessagesAB', 'true', { expires: 14 });
  }
});
